import { useEffect, useState } from "react";
import { firestore } from "./firebase";
import Sidebar from "./Sidebar";
import UpdateEvent from "./UpdateEvent";


export default function Upcoming() {
    const [eventDays, setEventDays] = useState();
    useEffect(() => {
        const today = new Date();
        let query = firestore.collection('events');
        query = query.where('start', '>=', new Date(today.getFullYear(), today.getMonth(), today.getDate())); //Start of today
        query = query.orderBy('start', 'asc').limit(100);
        query.onSnapshot(snapshot => setEventDays(eventDays => {
            if(!eventDays) eventDays = {};
            let currentDay;
            for(const event of snapshot.docs) {
                const d = event.data().start?.toDate();
                if(!d) continue;
                const eventDay = `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
                if(currentDay !== eventDay) {
                    currentDay = eventDay;
                    eventDays[currentDay] = [];
                    console.log(eventDay);
                }
                eventDays[currentDay].push(event);
            }
            return eventDays;
        }));
    }, []);

    return <div className="h-full flex w-auto">
        <Sidebar defaultOpen={false} />
        <div className="flex-grow overflow-auto">
            <div className="h-screen flex flex-col overflow-hidden">
                <div className="bg-gray-600 flex items-center text-white gap-2 p-3 justify-between">
                    <div className="text-l font-semibold">Anstehende Events</div>
                </div>
                <div className="p-3 overflow-y-scroll flex-col gap-10 flex">
                    {eventDays ? Object.entries(eventDays).map(([date, events]) => <div>
                        <div className="text-2xl mb-3">{new Date(date).toLocaleDateString('de-DE', {year: 'numeric', month: 'long', day: 'numeric'})}</div>
                        {events.map(event => <UpdateEvent key={event.id} object={event} />)}
                    </div>) : 'Bitte warten...'}
                    {Object.keys(eventDays ?? {}).length === 0 && <div>
                        Es wurden keine Events in der Zukunft gefunden.
                    </div>}
                </div>
            </div>
        </div>
    </div>;
}